module.exports = __webpack_public_path__ + "static/media/ic_data_dumps.dd21e957.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_data_dumps.svg
// module id = 302
// module chunks = 0